import useAuthorization from "./hooks/useAuthorization";
import {
  Alert,
  Autocomplete,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Snackbar,
  Typography
} from "@mui/material";
import DigitalSignature from "../../../../../../components/composed-styled-components/DigitalSignature/DigitalSignature";
const AuthorizationComponent = ({ open, onClose, onAutorizationDone ,userAuthorized,title="Autorización Supervisor",description =""}:any) => {
  const {
    usersList,
    password,
    loading,
    selectedUser,
    AuthError,
    SignatureOpen,
    handleUserChange,
    handleAuthorize,
    handlePasswordChange,
    setAuthError,
    setSignatureOpen,
    UpdateUserSignature,
  } = useAuthorization({ onAutorizationDone, onClose,userAuthorized });
  const isAuthorizeButtonDisabled = (!selectedUser && !userAuthorized)  || !password ;
// console.log('usersList ', usersList);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DigitalSignature
          open={SignatureOpen}
          onClose={() => setSignatureOpen(false)}
          onSave={(image:any) => {
            UpdateUserSignature(image, selectedUser.id,selectedUser.fullname);
          }}
        />
        {usersList && !userAuthorized && (
          <Autocomplete
            options={usersList}
            getOptionLabel={(option:any) => option.fullname}
            onChange={handleUserChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Seleccione Supervisor"
                variant="outlined"
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.fullname}
              </li>
            )}
          />
        )}
        <Typography>
          {description}
        </Typography>
        <TextField
          label="Contraseña"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={handlePasswordChange}
        />
        {/* Snackbar para mostrar el error */}
        <Snackbar
          open={AuthError}
          autoHideDuration={6000}
          onClose={() => setAuthError(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setAuthError(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            Hubo un error con la autorización.
          </Alert>
        </Snackbar>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button
          onClick={handleAuthorize}
          color="primary"
          disabled={isAuthorizeButtonDisabled}
        >
          {loading ? <CircularProgress size={24} /> : "Autorizar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthorizationComponent;
